// ************************************************************************************************************************************************************
//
// CONFIDENTIAL
// Unpublished Work, Copyright 2023, Baxter Healthcare Corporation. All rights reserved.
// For use only by Baxter Healthcare Corporation.
// This document contains proprietary information. It must not be reproduced
// or disclosed to others without prior written approval.
//
// Filename: Menudrawer.js
// Description: This file is responsible for All Header Elements
//
// ************************************************************************************************************************************************************
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from "react";
import clsx from "clsx";
import { Tooltip, InputBase, makeStyles, useTheme } from "@material-ui/core";
import { Drawer } from "@material-ui/core";
import { CssBaseline } from "@material-ui/core";
import { AppBar } from "@material-ui/core";
import { Toolbar } from "@material-ui/core";
import { List } from "@material-ui/core";
import { IconButton } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import NavigationPage from "../../../app/modules/sidebar/Sidebar";
import BasePage from "../../../app/BasePage";
import { Button } from "@material-ui/core";
import { Menu } from "@material-ui/core";
import { MenuItem } from "@material-ui/core";
import { Layout } from "../../../_metronic/layout";
import { ReactComponent as MonitorO } from "../../../icons/screen.svg";
import { ReactComponent as User } from "../../../icons/profile.svg";
import { ReactComponent as FacilitySvg } from "../../../icons/FacilitySvg.svg";
import searchblack from "../../../icons/searchblack.png";
import { ReactComponent as Plus } from "../../../icons/plus.svg";
import { ReactComponent as Trash } from "../../../icons/delete.svg";
import { ReactComponent as LogOut } from "../../../icons/logout.svg";
import { ReactComponent as Chevron } from "../../../icons/down-arrow.svg";
import { useOktaAuth } from "@okta/okta-react";
import AddUserPage from "../Users/pages/AddUserPage";
import AddMonitorPage from "../Monitors/pages/AddMonitorPage";
import AddFacilityPage from "../Facilities/pages/AddFacilityPage";
import * as Actions from "../redux/action";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core";
import debounce from "lodash/debounce";
import AddAssociatePage from "../Monitors/pages/AddAssociatePage";
import { MenuType, DEBOUNCE_TIME } from "../../../Application_Constants";
const drawerWidth = 235;
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    overflow: "hidden",
  },

  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    overflowX: "auto",
    top: "40px",
    border: "1px solid rgb(225, 225, 225)",
  },

  drawerHeader: {
    display: "flex",
    alignItems: "center",
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
    top: "150px",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    paddingLeft: "0px",
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  search: {
    position: "relative",
    borderRadius: "5px",
    border: "3px solid #158380",
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "white",
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "20ch",
      "&:focus": {
        width: "40ch",
      },
    },
  },
}));

function Menudrawer(props, prevProps) {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const { authState, oktaAuth } = useOktaAuth();
  const user = authState.idToken.claims.name;

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  /*
==================================================================================
Created On : 17/10/2023
Purpose: To show Add dialouges for facility , monitor, user and Associate
==================================================================================
*/
  const [monitorModalShow, SetmonitorModalShow] = useState(false);
  const [isEditMonitor, setisEditMonitor] = useState(true);
  const [facilities] = useState({});
  const [userModalShow, setUserModalShow] = useState(false);
  const [isEditUser, setisEditUser] = useState(true);
  const [facilityModalShow, setFacilityModalShow] = useState(false);
  const [isEditFacility, setisEditFacility] = useState(false);
  const [search, setSearchValue] = useState("");
  const debounceSearchDataMonitor = useCallback(
    debounce(onSearchMonitor, DEBOUNCE_TIME),
    [props.searchMonitor]
  );
  const debounceSearchDataFacility = useCallback(
    debounce(onSearchFacility, DEBOUNCE_TIME),
    [props.searchFacility]
  );
  const debounceSearchDataUser = useCallback(
    debounce(onSearchUser, DEBOUNCE_TIME),
    [props.searchUser]
  );
  /*
==================================================================================
Created On : 9/11/2023
Purpose: To blank search field
==================================================================================
*/
  useEffect(() => {
    if (
      prevProps.monitorDetails !== props.monitorDetails ||
      prevProps.facilityDetails !== props.facilityDetails
    ) {
      setSearchValue("");
    }
  }, [props.selectedMenu, props.monitorDetails, props.facilityDetails]);
  const [associateModalShow, setAssociateModalShow] = useState(false);

  const monitorModalClose = (opt) => {
    SetmonitorModalShow(false);
    setisEditMonitor(true);
    if (opt === "add") {
      props.MonitorListRefresh(true); //to refresh monitor grid
      props.refreshMonitorCount(true);
      props.refreshAssociateApi(true);
    }
  };

  const userModalClose = (opt) => {
    setUserModalShow(false);
    setisEditUser(true);
    if (opt === "add") {
      props.UserListRefresh(true); //to refresh user grid
      props.refreshUsercount(true);
    }
  };

  const facilitymodalClose = (opt) => {
    setFacilityModalShow(false);
    setisEditFacility(false);
    if (opt === "add") {
      props.refreshFacitityAcount(true); //to refresh facility grid
      props.refreshAssociateApi(true);
      props.FacilityListRefresh(true);
    }
  };

  const associatemodalClose = (opt) => {
    setAssociateModalShow(false);
    if (opt === "add") {
      props.MonitorListRefresh(true);
      props.refreshMonitorCount(true);
      props.refreshAssociateApi(true);
    }
  };

  const handleDeleteClick = () => {
    props.handleDelete(true);
  };
  const handleAssociateClick = () => {
    setAssociateModalShow(true);
    changeSearchValue("");
  };

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      boxShadow: theme.shadows[1],
      fontSize: 11,
      padding: "12px",
    },
  }))(Tooltip);

  const changeSearchValue = (value) => {
    setSearchValue(value);
    if (
      props.selectedMenu === MenuType.MONITOR_ALL ||
      props.selectedMenu === MenuType.MONITOR_ASSIGNED ||
      props.selectedMenu === MenuType.MONITOR_UNASSIGNED ||
      props.selectedMenu === MenuType.MONITOR_DELETED ||
      (props.selectedMenu === MenuType.FACILITY_ALL &&
        props.searchFacility !== "") ||
      props.selectedMenu === MenuType.ASSOCIATED_MONITORS
    ) {
      debounceSearchDataMonitor(value);
    }

    if (props.selectedMenu === MenuType.FACILITY_ALL) {
      debounceSearchDataFacility(value);
    }
    if (
      props.selectedMenu === MenuType.USER_ALL ||
      props.selectedMenu === MenuType.USER_INACTIVE ||
      props.selectedMenu === MenuType.USER_ACTIVE
    ) {
      debounceSearchDataUser(value);
    }
  };

  function onSearchMonitor(value) {
    props.searchMonitor(value);
  }
  function onSearchFacility(value) {
    props.searchFacility(value);
  }
  function onSearchUser(value) {
    props.searchUser(value);
  }

  const searchValidation = (e) => {
    e.target.value = e.target.value.replace(/'/g, "");
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        style={{
          display: "flex",
          flexDirection: "column",
          position: "fixed",
          top: "0",
          width: "calc(100vw - 64px)",
          left: "32px",
        }}
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <div>
          <Layout />
        </div>

        <Toolbar className="header-two">
          <div className="col-xs-12 menu-list">
            <IconButton
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={clsx(classes.menuButton, "menu-option", open)}
              style={{
                marginRight: "70px",
              }}
            >
              <span className="text">
                <MenuIcon /> Menu
              </span>
            </IconButton>
            {props.isSearchBar && (
              <div style={{ marginTop: "8px" }}>
                <div className={classes.search}>
                  <div className={classes.searchIcon}>
                    <img
                      src={searchblack}
                      alt="searchblack"
                      style={{
                        width: "20px",
                      }}
                    />
                  </div>
                  <InputBase
                    placeholder="Search"
                    style={{
                      fontFamily: "Noto Sans Display",
                      fontSize: "16px",
                    }}
                    classes={{
                      root: classes.inputRoot,
                      input: classes.inputInput,
                    }}
                    inputProps={{
                      "aria-label": "search",
                    }}
                    value={search}
                    onInput={searchValidation}
                    disabled={props.monitorDetails ? true : false}
                    onChange={(e) => {
                      changeSearchValue(e.target.value);
                    }}
                  />
                </div>
              </div>
            )}
            <div className="menu-option">
              <div>
                <Button
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                  className="add-btn"
                >
                  <Plus />
                  <span className="text"> Add</span>
                  <Chevron className="down-arrow" />
                </Button>
                <Menu
                  id="add-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem
                    onClick={() => {
                      SetmonitorModalShow(true);
                      setisEditMonitor(false);
                      setAnchorEl(false);
                      changeSearchValue("");
                    }}
                  >
                    <div>
                      <MonitorO className="teal" />
                    </div>

                    <div className="popuptext">Monitor</div>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setFacilityModalShow(true);
                      setisEditFacility(false);
                      setAnchorEl(false);
                      changeSearchValue("");
                    }}
                  >
                    <div>
                      <FacilitySvg className="teal" />
                    </div>
                    <div
                      className="popuptext"
                      style={{
                        marginLeft: "12px",
                      }}
                    >
                      Facility
                    </div>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setUserModalShow(true);
                      setisEditUser(false);
                      setAnchorEl(false);
                      changeSearchValue("");
                    }}
                  >
                    <div
                      style={{
                        marginLeft: "5px",
                      }}
                    >
                      <User className="teal" />
                    </div>
                    <div className="popuptext">User</div>
                  </MenuItem>
                </Menu>
              </div>
            </div>
            <div className="menu-option">
              <button
                className="text"
                onClick={() => {
                  handleAssociateClick();
                }}
              >
                <MonitorO />
                Associate
              </button>
            </div>
            <div className="menu-option">
              <button
                className="text"
                onClick={() => {
                  handleDeleteClick();
                }}
                disabled={
                  props.selectedMenu === MenuType.HELP ||
                  props.selectedMenu === MenuType.MONITOR_DELETED
                    ? true
                    : false
                }
              >
                <Trash />
                Delete
              </button>
            </div>
            <div className="spacing">
              <div className="menu-option">
                <span className="text">
                  <User />
                  {user}
                </span>
              </div>

              <div
                className="menu-option"
                style={{
                  marginLeft: "50px",
                }}
              >
                {authState.isAuthenticated && (
                  <LightTooltip
                    title=<span
                      style={{
                        fontSize: "18px",
                        fontFamily: "Noto Sans Display",
                      }}
                    >
                      Logout
                    </span>
                  >
                    <button
                      className="logout"
                      onClick={() => {
                        oktaAuth.signOut();
                      }}
                    >
                      <LogOut />
                    </button>
                  </LightTooltip>
                )}
              </div>
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        className={"ctmdrawer " + classes.drawer}
        variant="persistent"
        anchor="left"
        autoWidth={false}
        open={open}
        style={{
          top: "50vh",
          overflow: "hidden",
        }}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={handleDrawerClose} className="navigation">
            <span className="text">Navigation</span>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </div>
        <List>
          <NavigationPage />
        </List>
      </Drawer>
      <main
        className={
          clsx(classes.content, {
            [classes.contentShift]: open,
          }) + " SidebarNew"
        }
      >
        <div className={classes.drawerHeader} />
        <BasePage />
      </main>
      {!isEditMonitor ? (
        <AddMonitorPage
          is_edit={isEditMonitor.toString()}
          facility={props.selectedMenu}
          facilities={facilities}
          show={monitorModalShow}
          onHide={(value) => monitorModalClose(value)}
        ></AddMonitorPage>
      ) : null}
      {!isEditUser ? (
        <AddUserPage
          style={{ margin: "0" }}
          is_edit={isEditUser.toString()}
          facility={props.selectedMenu}
          facilities={facilities}
          show={userModalShow}
          onHide={userModalClose}
        ></AddUserPage>
      ) : null}
      <AddFacilityPage
        style={{ margin: "0" }}
        is_edit={isEditFacility.toString()}
        // edit_id={this.state.editId}
        show={facilityModalShow}
        onHide={facilitymodalClose}
      ></AddFacilityPage>
      <AddAssociatePage
        show={associateModalShow}
        onHide={associatemodalClose}
      ></AddAssociatePage>
    </div>
  );
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeMenu: Actions.changeSideBar,
      facilityDetailsChange: Actions.changefacilityDetails,
      changeFacilityMenu: Actions.changeFacility,
      refreshAssociateApi: Actions.refreshAssociateApi,
      refreshMonitorCount: Actions.refreshMonitorCount,
      refreshUsercount: Actions.refreshUsercount,
      refreshFacitityAcount: Actions.refreshFacitityAcount,
      FacilityListRefresh: Actions.FacilityListRefresh,
      searchUser: Actions.searchUser,
      searchMonitor: Actions.searchMonitor,
      searchFacility: Actions.searchFacility,
      FacilityName: Actions.FacilityName,
      handleDelete: Actions.handleDelete,
      MonitorListRefresh: Actions.MonitorListRefresh,
      UserListRefresh: Actions.UserListRefresh,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    selectedMenu: state.selectedMenu,
    isSearchBar: state.isSearchBar,
    selectedFacilities: state.selectedFacilities,
    searchMonitorValue: state.searchMonitor,
    searchUserValue: state.searchUser,
    searchFacilityValue: state.searchFacility,
    monitorDetails: state.monitorDetails,
    facilityDetails: state.facilityDetails,
    facilityName: state.facilityName,
    isAssociateApi: state.isAssociateApi,
    isDelete: state.isDelete,
    monitorListRefresh: state.monitorListRefresh,
    userListRefresh: state.userListRefresh,
    facilityListRefresh: state.facilityListRefresh,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Menudrawer);
